import * as React from "react";

export default () => (
	<svg
		x="0"
		y="0"
		width="100%"
		height="100%"
		viewBox="0.0000 0.0000 117 20"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="0.0000" width="1.0583" height="20.1864" />
		<rect x="1.5875" width="0.5292" height="20.1864" />
		<rect x="3.1750" width="0.5292" height="20.1864" />
		<rect x="5.8208" width="1.5875" height="20.1864" />
		<rect x="7.9375" width="1.0583" height="20.1864" />
		<rect x="9.5250" width="0.5292" height="20.1864" />
		<rect x="11.6417" width="0.5292" height="20.1864" />
		<rect x="13.7583" width="2.1167" height="20.1864" />
		<rect x="16.4042" width="0.5292" height="20.1864" />
		<rect x="17.4625" width="0.5292" height="20.1864" />
		<rect x="19.0500" width="2.1167" height="20.1864" />
		<rect x="22.2250" width="0.5292" height="20.1864" />
		<rect x="23.2833" width="0.5292" height="20.1864" />
		<rect x="24.8708" width="0.5292" height="20.1864" />
		<rect x="26.4583" width="2.1167" height="20.1864" />
		<rect x="29.1042" width="1.0583" height="20.1864" />
		<rect x="30.6917" width="1.0583" height="20.1864" />
		<rect x="32.8083" width="1.0583" height="20.1864" />
		<rect x="34.9250" width="0.5292" height="20.1864" />
		<rect x="35.9833" width="0.5292" height="20.1864" />
		<rect x="37.5708" width="2.1167" height="20.1864" />
		<rect x="40.7458" width="0.5292" height="20.1864" />
		<rect x="42.3333" width="0.5292" height="20.1864" />
		<rect x="43.3917" width="1.0583" height="20.1864" />
		<rect x="46.5667" width="0.5292" height="20.1864" />
		<rect x="47.6250" width="2.1167" height="20.1864" />
		<rect x="50.8000" width="0.5292" height="20.1864" />
		<rect x="52.3875" width="0.5292" height="20.1864" />
		<rect x="53.4458" width="2.1167" height="20.1864" />
		<rect x="56.6208" width="0.5292" height="20.1864" />
		<rect x="58.2083" width="1.0583" height="20.1864" />
		<rect x="59.7958" width="1.0583" height="20.1864" />
		<rect x="61.9125" width="1.0583" height="20.1864" />
		<rect x="64.0292" width="2.1167" height="20.1864" />
		<rect x="66.6750" width="1.5875" height="20.1864" />
		<rect x="68.7917" width="0.5292" height="20.1864" />
		<rect x="69.8500" width="0.5292" height="20.1864" />
		<rect x="70.9083" width="1.0583" height="20.1864" />
		<rect x="73.0250" width="0.5292" height="20.1864" />
		<rect x="75.6708" width="0.5292" height="20.1864" />
		<rect x="76.7292" width="2.1167" height="20.1864" />
		<rect x="79.9042" width="0.5292" height="20.1864" />
		<rect x="81.4917" width="0.5292" height="20.1864" />
		<rect x="82.5500" width="2.1167" height="20.1864" />
		<rect x="85.7250" width="0.5292" height="20.1864" />
		<rect x="87.3125" width="0.5292" height="20.1864" />
		<rect x="88.9000" width="0.5292" height="20.1864" />
		<rect x="89.9583" width="1.0583" height="20.1864" />
		<rect x="93.1333" width="0.5292" height="20.1864" />
		<rect x="94.7208" width="1.0583" height="20.1864" />
		<rect x="96.3083" width="0.5292" height="20.1864" />
		<rect x="98.9542" width="0.5292" height="20.1864" />
		<rect x="100.0125" width="1.0583" height="20.1864" />
		<rect x="102.1292" width="0.5292" height="20.1864" />
		<rect x="104.7750" width="0.5292" height="20.1864" />
		<rect x="105.8333" width="1.5875" height="20.1864" />
		<rect x="107.9500" width="1.0583" height="20.1864" />
		<rect x="110.5958" width="1.0583" height="20.1864" />
		<rect x="113.2417" width="1.5875" height="20.1864" />
		<rect x="115.3583" width="0.5292" height="20.1864" />
		<rect x="116.4167" width="1.0583" height="20.1864" />
	</svg>
);
